import React from "react";
import { Grid } from "@mui/material";
import AddExpRequirements from "./AddExpRequirements";
import StartEndDate from "./StartEndDate";

function DatesAndExperience({
  control,
  isEditPath,
  preloadedData,
  dateToday,
  startDate,
  endDate,
  errors,
  clearErrors,
  handleMaxExpBlur,
  handleMinExpBlur
}) {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <h3>Start and End Date</h3>
        <StartEndDate
          control={control}
          isEditPath={isEditPath}
          preloadedData={preloadedData}
          dateToday={dateToday}
          startDate={startDate}
          endDate={endDate}
          errors={errors}
          clearErrors={clearErrors}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <h3>Experience Requirements</h3>
        <AddExpRequirements
          control={control}
          preloadedData={preloadedData}
          handleMaxExpBlur={handleMaxExpBlur}
          handleMinExpBlur={handleMinExpBlur}
        />
      </Grid>
    </Grid>
  );
}

export default DatesAndExperience;
